import api from "../api";
function obter(setores, idPerfil) {
  return new Promise((resolve, reject) => {
    return api
      .get(`/api/log/obter?${setores}idPerfil=${idPerfil}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default {
  obter,
};
